<template>
	<div style="background-color: #fff">
		<div class="guide-module guide-content">
			<p class="guide-content-title">您的自我描述越精细，越能收到全国各地的需求推送</p>
			<div class="content-top">
				<span
					v-for="(item, index) in labelData"
					:key="index"
					:class="`label-data ${userType === item.userType ? 'active' : ''}`"
					@click="userTypeChange(item.userType)"
					>{{ item.label }}</span
				>
			</div>
			<Developer v-if="userType == '开发者'" :userType="userType" :dataSource="dataSource" :infoData="infoData" @refresh="infoDescription" />
			<Designer v-if="userType == '设计工程师'" :userType="userType" :dataSource="dataSource" :infoData="infoData" @refresh="infoDescription" />
			<Engineer v-if="userType == '技术工程师'" :userType="userType" :dataSource="dataSource" :infoData="infoData" @refresh="infoDescription" />
			<!-- <ContainerPage
            status={this.state.status}
            style={{ padding: 0 }}
          >
            { this.renderFormData() }
          </ContainerPage> -->
		</div>
	</div>
</template>

<script>
import { UserService } from "@/service";
import Developer from "./developer.vue";
import Designer from "./designer.vue";
import Engineer from "./engineer.vue";
export default {
	components: {
		Developer,
		Designer,
		Engineer,
	},
	data() {
		return {
			unicode: 0,
			dataSource: [],
			userType: "",
			status: "success",
			labelData: [
				{ label: "我是设计工程师", value: 2, userType: "设计工程师" },
				{ label: "我是技术工程师", value: 3, userType: "技术工程师" },
				{ label: "我是二次开发工程师", value: 1, userType: "开发者" },
			],
			infoData: {},
		};
	},
	methods: {
		listUserLabel() {
			UserService.listUserLabel().then((res) => {
				if (res.code == 0) {
					this.dataSource = res.data || [];
				}
			});
		},
		infoDescription() {
			UserService.infoDescription().then((res) => {
				if (res.code == 0) {
					this.infoData = res.data || {};
					this.userType = this.infoData.userType || "开发者";
				}
			});
		},
		userTypeChange(userType) {
			this.userType = userType;
		},
	},
	created() {
		this.listUserLabel();
		this.infoDescription();
	},
};
</script>

<style lang="less" scoped>
@import "./skill.less";
</style>
